import { Counter } from './Counter';

export type { TypeCounterProps } from './types';
export default Counter;
